import type { SortKey } from "@/lib/video";

interface SortBarProps {
  total: number;
  sort: SortKey;
  onSortChange: (sort: SortKey) => void;
  onOpenFilter: () => void;
  activeFilterCount: number;
}

const sortOptions: { value: SortKey; label: string }[] = [
  { value: "latest", label: "最新" },
  { value: "hot", label: "最热" },
  { value: "duration", label: "时长" },
];

export default function SortBar({
  total,
  sort,
  onSortChange,
  onOpenFilter,
  activeFilterCount,
}: SortBarProps) {
  return (
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3">
      <p className="text-sm text-foreground-500">
        共找到 <span className="font-medium text-foreground-900">{total}</span> 个视频
      </p>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onOpenFilter}
          className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 lg:hidden"
        >
          <i className="ri-filter-3-line text-base" />
          筛选
          {activeFilterCount > 0 && (
            <span className="flex h-4 w-4 items-center justify-center rounded-full bg-primary-500 text-[10px] text-background-50">
              {activeFilterCount}
            </span>
          )}
        </button>
        <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
          {sortOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onSortChange(option.value)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
                sort === option.value
                  ? "bg-background-50 text-primary-600"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}